import {
  CORE_LOAD_ALL_FLOOR_REQUEST,
  CORE_LOAD_ALL_FLOOR_SUCCESS,
  CORE_LOAD_ALL_FLOOR_FAILURE
} from '../types'
const requestState = 'request'
  , initialState = []
// , initialStateObj = {}
export default {
  allfloor: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_FLOOR_REQUEST:
        return requestState
      case CORE_LOAD_ALL_FLOOR_SUCCESS:
        let result = []
        if (result && Array.isArray(action.payload)) {
          result = action.payload
        }
        return result
      case CORE_LOAD_ALL_FLOOR_FAILURE:
        return initialState
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerFloor.js